import React from 'react'
import Account from '../components/account/Account'
function Home() {
  return (
    <Account/>
  )
}

export default Home